module.exports = "pegasus/assets/blocks/column-lp10-basic.png";